import React from "react";
import { DailyView } from "./DailyView";
import { MonthlyView } from "./MonthlyView";
import { WeeklyView } from "./WeeklyView";

export const TimelineGrid = ({ viewType, activePopup, currentYear }) => {
  switch (viewType) {
    case "monthly":
      return (
        <MonthlyView activePopup={activePopup} currentYear={currentYear} />
      );
    case "weekly":
      return <WeeklyView activePopup={activePopup} currentYear={currentYear} />;
    case "daily":
      return <DailyView activePopup={activePopup} currentYear={currentYear} />;
    default:
      return (
        <div className="text-red-500 p-2">Invalid view type: {viewType}</div>
      );
  }
};
